import { Component } from '@angular/core';

@Component({
  selector: 'app-page-educacao-tecnologica',
  templateUrl: './page-educacao-tecnologica.component.html',
  styleUrls: ['./page-educacao-tecnologica.component.scss'],
})
export class PageEducacaoTecnologicaComponent {}
